import Cookies from 'js-cookie'

const tokenkey = '';

export function getToken() {
    return Cookies.get(tokenkey);
}

export function setToken(token, time) {
    if(time){
        return Cookies.set(tokenkey, token, {expires: 7});
    }else{
        return Cookies.set(tokenkey, token);
    }
}

export function removeToken() {
    return Cookies.remove(tokenkey);
}